import { BaseEntity } from "yt-ng-framework";

export class GotovinskiKomitentView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    Pib: string = null;
    MatBr: string = null;
    MestoNaziv: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Pib = input.Pib;
        this.MatBr = input.MatBr;
        this.MestoNaziv = input.MestoNaziv;

        return this;

    }

    Serialize(input:GotovinskiKomitentView){
        return input;
    }
}